export enum ProgressCircleColor {
  BLACK = 'black',
  ICE = 'nordic-blue-900',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  GREY = 'nordic-blue-900',
  GOLD = 'loyalty-gold-dark',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  BLUE = 'nordic-blue-900',
}
